import { Pagination } from "react-bootstrap";
import { useSearch } from "../search/SearchProvider";
import TitleTooltip from "./TitleTooltip";

export default function Paginacion() {
  const { pagination ,handlePageChange } = useSearch();
  const pag = pagination ?? JSON.parse(localStorage.getItem('pagination'));
  // Calcular en total de páginas de la búsqueda
  //*** Comprobar que el objeto no este vacío **//
  /**
   * @param data.paginas
   * @param data.registros
   */
  let totalPages = Math.ceil(Number(pag.registros) / Number(pag.rpp));

  const arrayPages = [...Array(totalPages)];

  const currentPage = JSON.parse(localStorage.getItem('currentPage')) ?? Number(pag.pagina);

  function paginationChange(pageNumber){
    if (pageNumber !== currentPage){
      handlePageChange(pageNumber);
      localStorage.setItem("currentPage", JSON.stringify(pageNumber));
    }
  }

  return <>
    {
      totalPages > 0 ? (
          <div className="d-flex flex-stack flex-wrap flex-column-reverse py-3  flex-md-column-fluid">
            <div className="fs-6 fw-semibold text-gray-700 py-2">Total de resultados obtenidos <span
                className="fw-bolder">{pag.registros}</span>
            </div>
            <Pagination>
              {
                  totalPages > 1 && <>
                    <TitleTooltip title={"Primera página"} placement={'top'}>
                      <Pagination.First disabled={currentPage === 1} onClick={() => paginationChange(1)}/>
                    </TitleTooltip>
                    <TitleTooltip title={"Página anterior"} placement={'top'}>
                      <Pagination.Prev disabled={currentPage === 1} onClick={() => paginationChange(currentPage - 1)}/>
                    </TitleTooltip>
                  </>
              }
              {
                arrayPages.map((_, index) => {
                  return <TitleTooltip key={index + 1} title={"Página " + (index + 1)} placement={'top'}>
                    <Pagination.Item
                        onClick={() => paginationChange(index + 1)}
                        active={index + 1 === currentPage}
                        //disabled={index + 1 === currentPage}
                    >
                      {index + 1}
                    </Pagination.Item>
                  </TitleTooltip>
                })
              }
              {
                  totalPages > 1 && <>
                    <TitleTooltip title={"Siguiente página"} placement={'top'}>
                      <Pagination.Next disabled={currentPage === totalPages} onClick={() => paginationChange(currentPage + 1)}/>
                    </TitleTooltip>
                    <TitleTooltip title={"Última página"} placement={'top'}>
                      <Pagination.Last disabled={currentPage === totalPages} onClick={() => paginationChange(totalPages)} />
                    </TitleTooltip>
                  </>
              }
            </Pagination>
          </div>
      ) : (<></>)
    }
  </>;
}
